import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const SearchInputContainer = styled.div`
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: space-around;
    transition: all 0.5s ease;

    ${({ isTerminal }) =>
        isTerminal &&
        css`
            padding: 10px;

            .view-search-box-back-btn {
                margin-top: 5px;
            }
        `};
`;

export const ViewSearchForm = styled.form`
    max-width: 800px;
    width: 100%;
    height: auto;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    transition: all 1s ease;

    input {
        outline: none;
        position: relative;
        width: 100%;
        height: 45px;
        border-radius: 5px;
        border: 1px solid ${({ theme }) => theme.borders.neutralBorder};
        box-sizing: border-box;
        padding: 12px 48px;
        text-align: center;
        background-color: ${({ theme }) => theme.bg.secondaryWhite};
        color: ${({ theme }) => theme.text.neutralBlack};
        font-size: 14px;
        transition: all 0.5s ease;

        &::placeholder {
            color: inherit;
            font-size: 13px;
        }
        &:not(:placeholder-shown) + img {
            left: 10px;
        }
    }

    img {
        left: calc(50% - 73px);
        transition: all 0.5s ease;
        width: 18px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin: 0;
    }

    ${({ isMobile }) =>
        isMobile &&
        css`
            input {
                width: 100%;
                max-width: 100%;
                padding: 12px 12px 12px 38px;
                text-align: left;
            }

            img {
                left: 12px;
            }
        `};
`;

export const ViewSearchBoxCancelButton = styled.span`
    text-align: center;
    font-size: 14px;
    color: #1c3e60;
    cursor: pointer;
    position: absolute;
    right: 0;
    padding: 14px 10px;
    top: 50%;
    transform: translateY(-50%);
    animation: ${fadeIn} 0.5s ease forwards;
`;
